<template>
  <div class="calendar-box">
    <div class="calendar-main pt-3 pb-2">
      <div class="calendar">
        <div class="calendar-top">
          <slot name="top"></slot>
          <p class="show-btn mb-3 px-3" @click="showReport">查看上月月报</p>
        </div>
        <div class="day-title clearfix">
          <div class="day-tt" v-for="day in days" :key="day">{{ day }}</div>
        </div>
        <div
          class="date-main clearfix"
          :class="{
            'date-icon-up': icon,
            'date-icon-down': !icon,
          }"
        >
          <div
            :class="{ 'date-item': true, 'is-last-month': true }"
            v-for="(item, index) in nunDays"
            :key="index + 'num'"
          >
            <div class="day">{{ item }}</div>
          </div>
          <div
            :class="{
              'date-item': true,
              'is-last-month': false,
            }"
            v-for="(item, index) in list"
            :key="index"
            @click="queryDeal(item)"
          >
            <div
              class="day"
              :class="{
                today: item.curDay && curYearMonth === choseYearMonth,
                active: item.isActive,
                isException: item.datas.isArrive && item.datas.isException == 1,
                normal: item.datas.isArrive && item.datas.isException == 0,
              }"
            >
              {{ item.date }}
            </div>
          </div>
        </div>
        <div class="date-icon" v-if="iconFlag">
          <van-icon name="arrow-up" @click="setUpDate" />
        </div>
        <div class="date-icon" v-else>
          <van-icon name="arrow-down" @click="setDownDate" />
        </div>
      </div>
      <!-- <div class="detail-content mt-4 pt-2 px-2" v-if="attendance">
        <p v-if="attendance.FTWT">
          有效出勤数：{{ parseInt(attendance.FTWT) }}
        </p>
        <p v-if="attendance.O001">
          平时加班(计薪)：{{ parseInt(attendance.O001) }}
        </p>
        <p v-if="attendance.O002">
          周末加班(计薪)：{{ parseInt(attendance.O002) }}
        </p>
        <p v-if="attendance.ABST">
          旷工时数(计薪)：{{ parseInt(attendance.ABST) }}
        </p>
        <p v-if="attendance.O003">
          平时加班(调休)：{{ parseInt(attendance.O003) }}
        </p>
        <p v-if="attendance.O004">
          周末加班(调休)：{{ parseInt(attendance.O004) }}
        </p>
        <p v-if="attendance.L003">调休假：{{ parseInt(attendance.L003) }}</p>
        <p v-if="attendance.L015">出差：{{ parseInt(attendance.L015) }}</p>
        <p v-if="attendance.L002">年假：{{ parseInt(attendance.L002) }}</p>
        <p v-if="attendance.L005">病休假：{{ parseInt(attendance.L005) }}</p>
        <p v-if="attendance.L001">事假：{{ parseInt(attendance.L001) }}</p>
        <p v-if="attendance.L004">病假：{{ parseInt(attendance.L004) }}</p>
        <p v-if="attendance.L006">丧假：{{ parseInt(attendance.L006) }}</p>
        <p v-if="attendance.L006">婚假：{{ parseInt(attendance.L006) }}</p>
        <p v-if="attendance.L007">产假：{{ parseInt(attendance.L007) }}</p>
        <p v-if="attendance.L009">陪产假：{{ parseInt(attendance.L009) }}</p>
        <p v-if="attendance.L013">哺乳假：{{ parseInt(attendance.L013) }}</p>
        <p v-if="attendance.L014">工间假：{{ parseInt(attendance.L014) }}</p>
        <p v-if="attendance.L012">探亲假：{{ parseInt(attendance.L012) }}</p>
      </div> -->
    </div>
    <div>
      <slot name="content"></slot>
    </div>
    <div class="record-content mt-2 p-4" v-if="attendance && Object.keys(attendance).length > 0">
      <p class="sec-title">打卡记录</p>
      <div class="record-box mt-5 px-1" v-if="attendance.list.length != 0">
        <div
          class="label"
          v-for="(item, index) in attendance.list"
          :key="index"
        >
          <span class="mr-2">{{ index + 1 }}</span
          >{{ item | formatterDate }}
        </div>
      </div>
      <div class="exception mt-5 px-1">
        <div
          class="employee"
          v-if="attendance.wfurl != undefined && attendance.wfurl != ''"
        >
          <span class="mr-2"></span>
          <p>
            异常
            <!-- <span class="btn" @click="dealException">补卡</span> -->
            <span
              class="btnTwo"
              v-if="
                attendance.apply_times !== 0 &&
                attendance.apply_times !== undefined
              "
              @click="toInfoList"
              >已补卡{{ attendance.apply_times }}次</span
            >
          </p>
        </div>
        <div
          class="normal"
          v-if="attendance.wfurl != undefined && attendance.wfurl == ''"
        >
          <span class="mr-2">1</span>
          <p>异常2 <span>(若有疑问，请联系对应考勤负责人)</span></p>
        </div>
      </div>
    </div>

     <van-overlay :show="loading" class-name="global-loading">
       <van-loading size="32px" type="spinner" vertical >加载中...</van-loading>
    </van-overlay>

  </div>
</template>

<script>
const today = new Date();
import utils from "@/assets/js/utils";
import api from "@/apis";

export default {
  props: {
    nowMonth: {
      type: String,
      default: "",
    },
    isPointer: {
      type: Boolean,
      default() {
        return true;
      },
    },
    posttype: {
      type: [String, Number],
      default: "",
    },
  },
  watch: {
    nowMonth(val) {
      this.choseYearMonth = val;
      let c = val + "-01";
      this.loading = true;
      this.year = new Date(c.replace(/-/g, "/")).getFullYear();
      this.month = new Date(c.replace(/-/g, "/")).getMonth() + 1;
      this.qEQCalendar();
    },
    calendarData(val) {
      this.dealData(val);
    },
  },
  filters: {
    formatterDate(val) {
      return utils.formatDate(
        new Date(val.replace(/-/g, "/")).getTime() / 1000,
        "yyyy-MM-dd hh:mm"
      );
    },
  },
  data() {
    return {
      loading: true,
      days: ["日", "一", "二", "三", "四", "五", "六"],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,

      list: [], // 当前月的所有天数
      dealDataFinal: [], // 处理接口数据之后获得的最终的数组
      nunDays: [],
      testDays: ["日", "一", "二", "三", "四", "五", "六"],
      calendarData: null,
      curYearMonth: utils.formatDate(new Date().getTime() / 1000, "yyyy-MM"), // 当前时间 年月
      choseYearMonth: utils.formatDate(new Date().getTime() / 1000, "yyyy-MM"), // 选择的时间 年月
      attendance: null,
      isException: false,
      cardDate: "",
      icon: null,
      iconFlag: true,
    };
  },
  computed: {
    // 获取 select框中展示的具体月份应对应的月数
    monthDays() {
      const lastyear = this.year;
      const lastMon = this.month;
      const monNum = new Date(lastyear, lastMon, 0).getDate();
      // return this.$mp.dateFun.GetMonthDays(this.year.substr(0, 4), lastMon);
      return monNum;
    },
  },
  methods: {
    setUpDate() {
      this.icon = true;
      this.iconFlag = false;
    },
    setDownDate() {
      this.icon = false;
      this.iconFlag = true;
    },
    monthFisrtDay() {
      // 所指的星期中的某一天，使用本地时间。返回值是 0（周日） 到 6（周六） 之间的一个整数
      // eslint-disable-next-line radix
      const currDT = this.year + "/" + this.month + "/1";
      let currWeek = new Date(currDT).getDay();
      return ++currWeek || 7;
    },
    // 刷新日历 获得上个月的结尾天数 <=7
    refreshCalendar() {
      this.nunDays = [];
      const lastDays = [];
      const lastMon = this.month - 1;
      let lastDay = new Date(
        new Date(this.year, lastMon).getTime() - 8.64e7
      ).getDate();
      for (let i = 1; i < this.monthFisrtDay(); i += 1) {
        lastDays.unshift(lastDay);
        lastDay -= 1;
      }
      this.nunDays = lastDays;
    },
    // 展示 日历数据
    getDatas() {
      if (this.dealDataFinal && this.dealDataFinal.length > 0) {
        this.list = [];
        const datas = this.dealDataFinal;
        const dataMap = {};
        if (datas.length > 0) {
          datas.forEach((item) => {
            item.dateStr = item.tstamp.substr(0, 10);
            item.date = item.tstamp.substr(8, 2);
            dataMap[item.date] = item;
          });
        }

        const curDay = new Date().getDate();
        for (let i = 1; i <= this.monthDays; i += 1) {
          let dateStr = String(i);
          let isCurDay = false;
          if (i == curDay) {
            isCurDay = true; // 表示刚好是今天(该日期 和网络上的今天是同一天)
          }
          dateStr = "0" + dateStr;
          dateStr = dateStr.substr(dateStr.length - 2);
          const dataObj = dataMap[dateStr];
          console.log(i,isCurDay,dataObj);
          
          if (dataObj) {
            this.list.push({
              date: i,
              curDay: isCurDay,
              datas: dataObj,
              isActive:this.choseYearMonth + "-01" ==dataObj.dateStr?true:false,
            });
          } else {
            this.list.push({
              date: i,
              curDay: isCurDay,
              datas: {},
            });
          }
        }

      } else {
        this.clearCalendar();
      }
    },
    clearCalendar() {
      this.list = [];
      for (let i = 1; i <= this.monthDays; i += 1) {
        this.list.push({
          date: i,
          datas: {},
        });
      }
    },

    // 处理接口返回的日历数据
    dealData(currDS) {
      const tempData = [];
      if (currDS.length > 0) {
        currDS.forEach((item) => {
          const temp = {
            tstamp: item.term,
            isException: item.IsException,
            week: this.testDays[
              new Date(item.term.replace(/-/g, "/")).getDay()
            ], // currDS.dates[i]: '2020-03-31'
            isArrive:
              today.getTime() >
              new Date(item.term.replace(/-/g, "/")).getTime(),
          };
          tempData.push(temp);
        });
        // this.dealDataFinal = tempData.filter(item => item.grade>0);
        this.dealDataFinal = tempData;
        this.refreshCalendar();
        this.getDatas();
      } else {
        this.dealDataFinal = null;
        this.getDatas();
      }
    },

    //切换日历
    qEQCalendar() {
      let nowMonth = this.choseYearMonth + "-01";
      this.getAttendance(nowMonth);
      this.getAttendanceDetail(nowMonth);
    },
    // 设置选中之后的逻辑
    queryDeal(item) {
      if (item.isActive) return;
      this.isException = item.datas.isException == 1;
      // 设置选中之后的效果
      if (this.list && this.list.length) {
        const tempList = [...this.list];
        tempList.forEach((singleObj) => {
          singleObj.isActive = item.date === singleObj.date;
        });
        this.list = tempList;
      }
      let nowDay = item.datas.dateStr;
      this.loading = true;
      this.getAttendanceDetail(nowDay);
    },
    getAttendance(month) {
      api.getAttendance({ month: month }).then((res) => {
        this.calendarData = res.data;
        this.dealData(this.calendarData);
      });
    },
    // 获取接口数据
    getAttendanceDetail(day) {
      this.cardDate = day;
      this.attendance = {};
      this.$emit("calenList", {});
      api.getAttendanceDetail({ date: day }).then((res) => {
        this.loading = false;
        this.attendance = res.data;
        this.$emit("calenList", res.data);
      });
    },
    dealException() {
      // location.href = this.attendance.wfurl;
      this.$router.push({
        path: "/mobile/cardReplacement",
        query: {
          data: this.cardDate,
        },
      });
    },
    toInfoList() {
      this.$router.push({
        path: "/mobile/infoList",
        query: {},
      });
    },
    showReport() {
      let str = this.choseYearMonth + "-01";
      let month = new Date(str.replace(/-/g, "/"));
      month.setMonth(new Date(str.replace(/-/g, "/")).getMonth() - 1); //上月
      this.$router.push({
        path: "/statistics",
        query: {
          month: utils.formatDate(month.getTime() / 1000, "yyyy-MM"),
          hiddenBtn: true, // 隐藏推送确认按钮
        },
      });
    },
  },
  mounted() {
    this.qEQCalendar();
    let sday = utils.formatDate(today.getTime() / 1000, "yyyy-MM-dd");
    Promise.resolve(this.qEQCalendar()).then(() => {
      this.getAttendanceDetail(sday);
    });
  },
};
</script>

<style lang="scss" scoped>
.global-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7); /* 85%不透明度 */
}
.r-inline {
  display: inline-block;
}
.calendar-box {
  .loading {
    position: fixed;
    top: 24%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .calendar-main {
    border-bottom-left-radius: 9px;
    border-bottom-right-radius: 9px;
    background-color: #ffffff;
  }
  // .detail-content {
  //   @include flex-start();
  //   flex-wrap: wrap;
  //   position: relative;
  //   &::after {
  //     content: "";
  //     display: block;
  //     width: 90%;
  //     height: 1px;
  //     position: absolute;
  //     top: 0;
  //     left: 50%;
  //     transform: translateX(-50%);
  //     background: #dedede;
  //   }

  //   & > p {
  //     font-size: 28px;
  //     font-family: SimHei;
  //     font-weight: 400;
  //     color: #1e1e1e;
  //     margin: 12px 20px;
  //   }
  // }
  .record-content {
    border-radius: 9px;
    background-color: #ffffff;
    .sec-title {
      font-size: 30px;
      font-family: SimHei;
      font-weight: 500;
      color: #1e1e1e;
    }
    .record-box {
      .label {
        font-size: 32px;
        font-family: SimHei;
        color: #1e1e1e;
        @include flex-start();
        align-items: center;
        & > span {
          display: inline-block;
          width: 30px;
          height: 30px;
          background: #7c808c;
          border-radius: 50%;
          font-size: 20px;
          font-family: SimHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 30px;
          text-align: center;
          position: relative;
        }
      }
      .label:not(:last-child) {
        margin-bottom: 100px;
        & > span {
          &::after {
            content: "";
            display: block;
            width: 1px;
            height: 94px;
            background: #7c808c;
            position: absolute;
            top: 34px;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
    }
    .exception {
      & > div {
        @include flex-start();
        align-items: center;
        & > span {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: #7c808c;
          border-radius: 50%;
          font-size: 18px;
          font-family: SimHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
          text-align: center;
          position: relative;
        }
        & > p {
          font-size: 32px;
          font-family: SimHei;
          color: #1e1e1e;
          & > span {
            font-size: 24px;
          }
          & > .btn {
            border: 1px solid #eca63c;
            border-radius: 6px;
            font-size: 20px;
            font-family: SimHei;
            font-weight: 500;
            color: #eca63c;
            padding: 2px 6px;
            margin-left: 10px;
          }
          & > .btnTwo {
            border: 1px solid #33853a;
            border-radius: 6px;
            font-size: 20px;
            font-family: SimHei;
            font-weight: 500;
            color: #2d8534;
            padding: 2px 6px;
            margin-left: 10px;
          }
        }
      }
    }
  }
}

.day-title {
  @include flex-around();
  .day-tt {
    color: #b5b4b7;
    width: 50px;
    height: 50px;
    font-size: 30px;
    line-height: 50px;
    text-align: center;
  }
}
.date-main {
  @include flex-start();
  flex-wrap: wrap;
  min-height: 80px;
}
.date-icon-up {
  height: 80px !important;
  overflow: hidden;
  transition: height 0.5s;
}
.date-icon-down {
  height: 450px !important;
  transition: height 0.5s;
}
.date-item {
  color: #1e1e1e;
  width: calc(100% / 7);
  // margin: 14px 0.19rem 14px 0.20rem;
  // margin: 14px 0.26rem;

  &.is-last-month {
    color: #7d8c8c;
  }
  .day {
    border-radius: 20px;
    width: 60px;
    height: 60px;
    margin: 0 auto;
    line-height: 64px;
    font-size: 30px;
    text-align: center;
    cursor: pointer;
  }
  .today {
    background: #e3f1fe;
    color: #3879d5;
  }
  .active {
    // background: #3879d5;
    background: rgba(78, 162, 124, 1);
    color: #ffffff;
  }
  .isException {
    &::after {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      // background: #f2a333;
      background: rgba(244, 35, 35, 1);
      position: relative;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .normal {
    &::after {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      // background: #3879d5;
      background: rgba(0, 135, 85, 1);
      position: relative;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.show-btn {
  @include flex-end();
  font-size: 26px;
  font-family: SimHei;
  font-weight: 500;
  color: #3879d5;
}
.calendar {
  padding: 0px 6px;
  .calendar-top{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .date-icon {
    font-size: 40px;
    text-align: center;
  }
}

.isPointer {
  cursor: pointer;
}
</style>
